import './admin-navbar.scss';

import { Menu } from 'antd';
import type { FC } from 'react';
import { useLocation } from 'react-router';

import { WIDTH_FOR_OPENED_NAVBAR } from '@/shared/constants';
import { useWindowSize } from '@/shared/hooks/useWindowSize';
import { LocalizedNavLink } from '@/shared/ui';
import { useAppDispatch } from '@/store';
import { setSidebarExpanded } from '@/store/user-info.slice';

import { adminSideBarItems } from '../../constants/navbar';

type TAdminNavBarProps = {
  isSidebarExpanded: boolean;
};

const AdminNavBar: FC<TAdminNavBarProps> = ({ isSidebarExpanded }) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [windowWidth] = useWindowSize();

  const onClick = () => {
    if (windowWidth < WIDTH_FOR_OPENED_NAVBAR)
      dispatch(setSidebarExpanded(false));
  };

  const menuItems = adminSideBarItems.map((item) => {
    const isActive = location.pathname.includes(item.key);

    return {
      key: item.key,
      icon: item.icon,
      label: (
        <LocalizedNavLink
          to={item.key}
          onClick={onClick}
          className="admin-navbar__link"
        >
          {item.label}
        </LocalizedNavLink>
      ),
      className: `admin-navbar__menu-item ${isActive ? 'ant-menu-item-selected admin-navbar__link--active' : ''}`
    };
  });

  return (
    <Menu
      mode="inline"
      theme="dark"
      inlineCollapsed={!isSidebarExpanded}
      className="admin-navbar"
      items={menuItems}
      selectedKeys={[location.pathname]}
      style={{
        marginLeft: isSidebarExpanded ? '-16px' : '0px',
        width: !isSidebarExpanded ? '50px' : '230px'
      }}
    />
  );
};

export default AdminNavBar;
